import React, { useState, useCallback } from 'react';
import Assistant from './pages/Assistant';
import Checklist from './pages/Checklist';
import Guides from './pages/Guides';
import Layout from './Layout';
import styles from './styles/App.module.css';

function App() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = useCallback((newValue) => {
    setActiveTab(newValue);
  }, []);

  return (
    <Layout activeTab={activeTab} onTabChange={handleTabChange}>
      <div
        className={`${styles.box} ${
          activeTab === 0 ? styles.visible : styles.preserved
        }`}
      >
        <Assistant />
      </div>
      <div
        className={`${styles.box} ${
          activeTab === 1 ? styles.visible : styles.preserved
        }`}
      >
        <Checklist isActive={activeTab === 1} />
      </div>
      <div
        className={`${styles.box} ${
          activeTab === 2 ? styles.visible : styles.preserved
        }`}
      >
        <Guides />
      </div>
    </Layout>
  );
}

export default App;
